import PostPointsBox from './PostPointsBox';

export type { PostPointsBoxProps } from './PostPointsBox';

export default PostPointsBox;
